var _defs, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOctorionTravelShadow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 218,
    viewBox: "0 0 109 218",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "octorion-travel-shadow-a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "-2.049%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DCE0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7BDC1"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#octorion-travel-shadow-a)",
    points: "629.953 2975 601 3192.395 709.528 3192.395 684.645 2975",
    transform: "translate(-601 -2975)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOctorionTravelShadow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/octorion-travel-shadow.b5a2b69d.svg";
export { ForwardRef as ReactComponent };